<template>
  <div style="display:flex; flex-direction: column; align-items:flex-end; gap: 8px;">
    <div style="display:flex; background:#fff; border:1px solid #e5e6e8; border-radius: 8px; padding: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
      <div
        v-for="opcao in opcoes"
        :key="opcao.valor"
        class="date-shortcut-pill"
        :class="{ 'date-shortcut-pill--ativo': opcao.valor === value }"
        @click="selecionar(opcao.valor)"
      >{{ opcao.label }}</div>
    </div>
    <div style="font-size: 12px; color: #9a9a9a; font-weight: 500;">{{ dataExtenso }}</div>
  </div>
</template>
<script>
// Seletor rapido ontem/hoje/amanha (requisito confirmado com o cliente pra
// issue #312 - nao precisa de calendario livre). Usa $formartData (ja
// existente no projeto) pra somar/formatar dias, evitando reimplementar
// matematica de data com fuso horario na mao.
export default {
  name: "DateShortcutFilter",
  props: {
    value: { type: String, required: true } // 'YYYY-MM-DD'
  },
  data() {
    return {
      opcoes: []
    };
  },
  computed: {
    dataExtenso() {
      if (!this.value) return "";
      const data = new Date(this.value + "T00:00:00");
      return data.toLocaleDateString("pt-BR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
    }
  },
  async created() {
    await this.montarOpcoes();
  },
  methods: {
    selecionar(valor) {
      // Evita disparar o @input (e o carregamento de dados no pai) de novo
      // quando o usuario clica na opcao ja selecionada.
      if (valor === this.value) return;
      this.$emit("input", valor);
    },
    async montarOpcoes() {
      let hoje, ontem, amanha;
      try {
        hoje = this.$formartData.dataFiltro();
        const ontemData = await this.$formartData.somarDias(hoje, -1);
        const amanhaData = await this.$formartData.somarDias(hoje, 1);
        ontem = await this.$formartData.formatar(ontemData, 1);
        amanha = await this.$formartData.formatar(amanhaData, 1);
      } catch (err) {
        // $formartData falhando nao pode deixar a tela travada em branco pra
        // sempre - cai pra um calculo local equivalente, so pra este caso.
        console.error("DateShortcutFilter: falha ao calcular ontem/hoje/amanhã via $formartData", err);
        const agora = new Date();
        hoje = agora.toISOString().slice(0, 10);
        const ontemLocal = new Date(agora);
        ontemLocal.setDate(ontemLocal.getDate() - 1);
        const amanhaLocal = new Date(agora);
        amanhaLocal.setDate(amanhaLocal.getDate() + 1);
        ontem = ontemLocal.toISOString().slice(0, 10);
        amanha = amanhaLocal.toISOString().slice(0, 10);
      }

      this.opcoes = [
        { label: "Ontem", valor: ontem },
        { label: "Hoje", valor: hoje },
        { label: "Amanhã", valor: amanha }
      ];

      // Sem valor inicial do pai, assume "hoje" e avisa via v-model - o pai
      // usa esse primeiro @input pra disparar o carregamento inicial.
      if (!this.value) {
        this.$emit("input", hoje);
      }
    }
  }
};
</script>
<style scoped>
.date-shortcut-pill {
  padding: 7px 16px; border-radius: 6px; font-size: 13px; font-weight: 500;
  color: #8b8b8b; cursor: pointer;
}
.date-shortcut-pill--ativo { font-weight: 700; color: #1f1f1f; background: #ffca00; }
</style>
